// src/components/ProtectedRoute.js
import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { isTokenExpired, refreshToken } from '../utils/auth';

const ProtectedRoute = ({ children }) => {
  const [authState, setAuthState] = useState({
    isAuthenticated: false,
    loading: true
  });

  useEffect(() => {
    const verifyAuth = async () => {
      const token = localStorage.getItem('token');
      
      // No token at all
      if (!token) {
        setAuthState({ isAuthenticated: false, loading: false });
        return;
      }

      // Token exists but might be expired
      try {
        if (isTokenExpired(token)) {
          const newToken = await refreshToken();
          if (!newToken) throw new Error('Refresh failed');
          localStorage.setItem('token', newToken);
        }
        setAuthState({ isAuthenticated: true, loading: false });
      } catch (error) {
        localStorage.removeItem('token');
        setAuthState({ isAuthenticated: false, loading: false });
      }
    };

    verifyAuth();
  }, []);

  if (authState.loading) {
    return <div className="full-page-loading">Loading authentication...</div>;
  }

  if (!authState.isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;